// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    CheqSettings,
    injectElementAttributes,
    OneTrustSettings,
    shouldGenerateScript,
} from "@eisinc/App/Components/XngScriptInjector/utils";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { FC, useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const { cheqSettings, oneTrustSettings } = getSettingsCollection(state);
    return {
        cheqSettings: cheqSettings as CheqSettings,
        oneTrustSettings: oneTrustSettings as OneTrustSettings,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

const XngScriptInjector: FC<Props> = ({ cheqSettings, oneTrustSettings }) => {
    const generateOnTrustScript = () => {
        if (!shouldGenerateScript(oneTrustSettings)) {
            return;
        }
        const script = document.createElement("script");
        script.async = true;
        injectElementAttributes(script, {
            src: oneTrustSettings.oneTrustSource,
            charset: "UTF-8",
            type: "text/javascript",
            "data-domain-script": oneTrustSettings.dataDomainScript,
        });
        oneTrustSettings.oneTrustSource && document.body.appendChild(script);
    };
    const generateCheqScript = () => {
        if (!shouldGenerateScript(cheqSettings)) {
            return;
        }
        const headScript = document.createElement("script");
        headScript.async = true;
        injectElementAttributes(headScript, {
            src: cheqSettings.cheqScriptUri,
            class: cheqSettings.cheqScriptClass,
            "data-ch": cheqSettings.cheqScriptDataCh,
            charset: "UTF-8",
            type: "text/javascript",
        });
        cheqSettings.cheqScriptUri && document.head.prepend(headScript);

        const bodyScript = document.createElement("noscript");
        const bodyIframe = document.createElement("iframe");
        injectElementAttributes(bodyIframe, {
            src: cheqSettings.cheqIframeSource,
            width: "0",
            height: "0",
            style: "display:none;",
        });
        bodyScript.appendChild(bodyIframe);
        cheqSettings.cheqIframeSource && document.body.prepend(bodyScript);
    };
    const generateBynderScript = () => {
        const script = document.createElement("script");
        script.async = true;
        injectElementAttributes(script, {
            src: 'https://ucv.bynder.com/5.0.5/modules/compactview/bynder-compactview-3-latest.js',
            charset: "UTF-8",
            type: "text/javascript",
        });
        document.body.appendChild(script);
    }
    useEffect(() => {
        generateOnTrustScript();
        generateCheqScript();
        generateBynderScript();
    }, []);

    return null;
};

export default connect(mapStateToProps)(XngScriptInjector);
